import { Paper } from '@mui/material';
import * as React from 'react';
import { API_SERVER } from '../../common/api';
import usePaginationHook from '../../common/hook/usePaginationHook';
import EncounterList from '../component/encounter/EncounterList';
import FilterEncounterBox from '../component/encounter/FilterEncounterBox';
import ReceiveWizardDialog from '../component/encounter/ReceiveWizardDialog';
import { useSelector } from 'react-redux';
import { AppState } from '../../../redux/reducer';
import { ENCOUNTER_STATUS } from 'modules/common/apiConstants';
import { useFetch } from 'modules/common/hook/useFetch';
import { formatDateFilterField } from 'modules/common/utils';
import PageHeader from 'modules/common/component/PageHeader';
import { useDialog } from 'modules/common/hook';

interface Props {}

const EncounterListPage: React.FunctionComponent<Props> = () => {
  const [openRegisterDialog, onOpenRegisterDialog, onCloseRegisterDialog] = useDialog();
  const orderEncounter = useSelector((appState: AppState) => appState.common.orderEncounter);
  const hookPagination = usePaginationHook({
    defaultFilter: {
      status: [ENCOUNTER_STATUS.INPROGRESS.value, ENCOUNTER_STATUS.ARRIVED.value, ENCOUNTER_STATUS.FINISHED.value],
      orderBy: orderEncounter,
    },
  });
  const { params } = hookPagination;

  const {
    data: encounterPage,
    isValidating,
    revalidate,
  } = useFetch(API_SERVER.encounter.search(formatDateFilterField(params, 'fromDate', 'toDate')));

  return (
    <Paper elevation={1} style={{ padding: 16, flex: 1, overflow: 'hidden' }}>
      <FilterEncounterBox
        dataLoading={isValidating}
        hookPagination={hookPagination}
        onRegisterButtonClick={onOpenRegisterDialog}
        pagin={
          <PageHeader
            titleKey="encounterList"
            pagination={{
              size: encounterPage?.content.length || 0,
              totalElements: encounterPage?.pagination.totalElements || 0,
            }}
          />
        }
      />
      <EncounterList
        refresh={revalidate}
        encounters={encounterPage?.content}
        total={encounterPage?.pagination?.totalElements || 0}
        hookPagination={hookPagination}
        loading={isValidating}
      />
      <ReceiveWizardDialog open={openRegisterDialog} close={onCloseRegisterDialog} refresh={revalidate} mode="CREATE" />
    </Paper>
  );
};

export default EncounterListPage;
